import { bem as _bem } from "~/shared/styles";

export const bem = _bem("drawer-nav");
